import React from 'react';

import {
  ListRenderItemInfo,
  View,
  VirtualizedList,
  useWindowDimensions,
} from 'react-native';

import {useFolders} from '../../hooks/useFolders';

import {ActivityIndicator} from 'react-native-paper';
import {FolderPreviewContentType, FolderType} from '../../types';
import FolderLibrary from './folderlibrary';
import {useFolder} from '../../hooks/useFolder';
import DragList from 'react-native-draglist';
import {useAppSelector} from '../../store/hooks';

export type RenderContentType = (
  item: ListRenderItemInfo<FolderPreviewContentType>,
) => JSX.Element;

export const FolderNavigator = ({
  parentFolderId,
  parentFolderHook,
  renderContent,
  folderType,
}: {
  renderContent: RenderContentType;
  parentFolderId: string | null;
  parentFolderHook: ReturnType<typeof useFolder>;
  folderType: FolderType;
}) => {
  const foldersHook = useFolders(folderType, false);
  const {height} = useWindowDimensions();
  const hasMedia = useAppSelector(
    state => state.media.currentMediaId !== undefined,
  );
  const dynamicHeight = hasMedia ? height / 2 : height;
  return (
    <View style={{width: '30%', height: dynamicHeight}}>
      {!parentFolderId ? (
        <FolderLibrary dataHook={foldersHook} />
      ) : null}
      {parentFolderId ? (
        <>
          {!parentFolderHook.folderContentQuery.isFetching &&
          !parentFolderHook.isLoadingFolder &&
          parentFolderHook.folderContent?.length ? (
            <DragList
              onEndReached={() => {
                console.info('onEndReached');
                // parentFolderHook.folderContentQuery.refetch()
              }}
              scrollEnabled={true}
              style={{height: dynamicHeight, paddingBottom: 100}}
              data={parentFolderHook.folderContent || []}
              pagingEnabled={true}
              initialNumToRender={1000}
              renderItem={renderContent}
              keyExtractor={(item: FolderPreviewContentType) =>
                item.id || item.date.toString()
              }
              onReordered={parentFolderHook.onReordered}
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
              // getItemCount={parentFolderHook.getContentCount}
              // getItem={parentFolderHook.getContentItem}
              // onScrollToTop={() => {
              //   // console.info('ontop');
              // }}
              // getItemLayout={(_data, index) => ({
              //   length: 130,
              //   offset: 130 * index,
              //   index,
              // })}
            />
          ) : (
            <ActivityIndicator size={72} />
          )}
        </>
      ) : null}
    </View>
  );
};
